import _find from 'lodash/find';
import unregisterStudentTemplate from './../../dashboard/unregister-student/unregister-student.html';
import template from './invalid-attendances.html';

class InvalidAttendancesComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, moment,
    StudentService,
    CategoryOfDepartureService,
    AttendanceService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.StudentService = StudentService;
    this.CategoryOfDepartureService = CategoryOfDepartureService;
    this.AttendanceService = AttendanceService;

    this.selectedInvalidAttendancesIds = [];
  }

  loadAttendances() {
    return this.StudentService.getAttendances({
      invalid: true,
      showLoaderSpinner: true
    }).then(result => {
      this.invalidAttendances.splice(0, this.invalidAttendances.length);
      Object.assign(this.invalidAttendances, result);
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać frekwencji')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  getAttendance(id) {
    return {..._find(this.invalidAttendances, item => item.id === id)};
  }

  closeAttendance(id, ev) {
    const attendance = _find(this.invalidAttendances, item => item.id === id);
    this.openCloseAttendanceDialog(attendance, ev);
  }

  openCloseAttendanceDialog(attendance, ev) {
    this.CategoryOfDepartureService.getAll().then(categoriesOfDeparture => {
      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'UnregisterStudentController',
        locals: {
          attendances: [attendance],
          categoriesOfDeparture,
          departureCategory: null,
          comment: ''
        },
        template: unregisterStudentTemplate,
        disableParentScroll: true,
        clickOutsideToClose: true,
        targetEvent: ev
      })
        .then(() => {
          this.loadAttendances();
        });
    });
  }

  removeAttendances(ids, ev) {
    const confirm = this.$mdDialog.confirm()
      .title('Czy na pewno chcesz usunąć frekwencję?')
      .textContent('Usuniętej frekwencji nie będzie można przywrócić.')
      .ariaLabel('Usunięcie frekwencji')
      .targetEvent(ev)
      .ok('Usuń')
      .cancel('Zamknij');

    if (ids.length > 1) {
      confirm.title('Czy na pewno chcesz usunąć frekwencje?');
      confirm.textContent('Usuniętych frekwencji nie będzie można przywrócić.');
    }

    this.$mdDialog.show(confirm).then(() => {
      this.AttendanceService.destroy(ids.join())
        .then(() => {
          this.loadAttendances().then(() => {
            this.selectedInvalidAttendancesIds = [];
          });
          this.$mdDialog.hide();
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Usunięto frekwencję')
              .position('bottom right')
              .hideDelay(3000)
          );
        })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    });
  }

  selectedRowCallback(rowsIds) {
    this.selectedInvalidAttendancesIds = rowsIds;
  }
}

export const InvalidAttendances = {
  bindings: {
    invalidAttendances: '<'
  },
  template,
  controller: InvalidAttendancesComponent
};
